import React, { useState, useEffect, useCallback } from "react";
import styles from "./Filters.module.css";
import MultiSelectFilter from "./MultiSelectFilter";
import { useCountries } from "../../../hooks/useCountries";

const mouStatus = [
 {label:"MoU Signed", value:"MoU Signed"},
 {label:"MoU Under Discussion", value:"MoU Under Discussion"},
 {label:"Expression of Interest (EOI Received)", value:"Expression of Interest (EOI Received)"},
 {label:"Proposal Sent", value:"Proposal Sent"},
 {label:"Proposal Approved", value:"Proposal Approved"},
 {label:"Collaboration Active", value:"Collaboration Active"},
 {label:"Collaboration Inactive / On Hold", value:"Collaboration Inactive / On Hold"},
 {label:"MoU Expired", value:"MoU Expired"},
];

export default function Filters({ onFilterChange, currentFilters, organizations }) {
  const [localFilters, setLocalFilters] = useState({
    regions: [],
    mou: [],
    organization: []
  });
  const { countries } = useCountries();

  useEffect(() => {
    // Only update if currentFilters actually changed to prevent unnecessary re-renders
    if (JSON.stringify(localFilters) !== JSON.stringify(currentFilters)) {
      setLocalFilters(currentFilters);
    }
  }, [currentFilters]);

  // Convert country values back to country objects for display
  const getCountryObjects = (countryValues) => {
    return countryValues.map(value => 
      countries.find(country => country.value === value) || value
    );
  };

  // Format organization data for MultiSelectFilter
  const getOrganizationObjects = (organizationValues) => {
    if (!organizationValues || !Array.isArray(organizationValues) || organizationValues.length === 0) {
      return [];
    }
    
    if (!organizations || organizations.length === 0) {
      return organizationValues.map(value => ({ label: value, value }));
    }
    
    return organizationValues.map(value => {
      const org = organizations.find(organization => organization.id === value || organization.value === value);
      return org ? { label: org.name, value: org.value || org.name } : { label: value, value };
    });
  };

  const handleMultiSelectChange = (filterKey, selectedItems) => {
    // Merge with currentFilters from parent to preserve all filter properties
    const newFilters = { ...currentFilters, [filterKey]: selectedItems };
    setLocalFilters({
      ...localFilters,
      [filterKey]: selectedItems
    });
    onFilterChange(newFilters);
  };

  const handleClearAllFilters = () => {
    const resetFilters = {
      allType: [],
      instituteType: [],
      regions: [],
      mou: [],
      organization: []
    };
    setLocalFilters({
      regions: [],
      mou: [],
      organization: []
    });
    onFilterChange(resetFilters);
  };

  return (
    <div className={styles.filters}>
      <div className={styles.container}>
       <button className={styles.filterBtn}> Filters</button>
        <MultiSelectFilter
          dropdownTitle="Country"
          placeholder="Search country..."
          fetchData={(query) =>
            Promise.resolve(
              countries.filter((country) =>
                country.label.toLowerCase().includes(query.toLowerCase())
              )
            )
          }
          selected={getCountryObjects(localFilters.regions)}
          onSelectionChange={(selected) =>
            handleMultiSelectChange("regions", selected)
          }
        />
        
        <MultiSelectFilter
          dropdownTitle="Knowledge Partner type"
          placeholder="Search organization..."
          fetchData={(query) =>
            Promise.resolve(
              organizations.filter((org) => {
                const orgName = org.name || org.label || '';
                return orgName.toLowerCase().includes(query.toLowerCase());
              }).map(org => ({ label: org.name, value: org.value }))
            )
          }
          selected={getOrganizationObjects(localFilters.organization)}
          onSelectionChange={(selected) =>
            handleMultiSelectChange("organization", selected)
          }
        />
        <MultiSelectFilter
          dropdownTitle="mou status"
          placeholder="Search MOU..."
          fetchData={(query) =>
            Promise.resolve(
              mouStatus.filter((status) =>
                status.label.toLowerCase().includes(query.toLowerCase())
              )
            )
          }
          selected={localFilters.mou}
          onSelectionChange={(selected) =>
            handleMultiSelectChange("mou", selected)
          }
        />
        <button 
          className={styles.clearBtn}
          onClick={handleClearAllFilters}
        >
          Clear Filters
        </button>
      </div>  
    </div>
  );
}
